import ChevronDownSvg from 'global/Securities/components/Icons/ChevronDownSvg';
import { ReactNode, useState } from 'react';
import {
  Chevron,
  Container,
  ContentContainer,
  HeaderContainer,
  HeaderContent,
} from './styled';

interface Props {
  children: ReactNode;
  defaultOpenState?: boolean;
  header?: ReactNode;
  maxHeight?: string;
  expandDirection?: 'top' | 'bottom';
}

function Collapsible({
  children,
  defaultOpenState = false,
  header = <></>,
  maxHeight = '300px',
  expandDirection = 'top',
}: Readonly<Props>) {
  const [isOpen, setIsOpen] = useState(defaultOpenState);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container direction={expandDirection}>
      <ContentContainer isOpen={isOpen} maxHeight={maxHeight}>
        {children}
      </ContentContainer>
      <HeaderContainer onClick={toggleCollapsible}>
        <HeaderContent>{header}</HeaderContent>
        <Chevron direction={isOpen ? 'top' : 'bottom'}>
          <ChevronDownSvg />
        </Chevron>
      </HeaderContainer>
    </Container>
  );
}

export default Collapsible;
